import * as actions from './slice'

export const getAccelerateStatus = (hooks) => {
  return {
    eventName: 'accelerateGetStatus',
    onSuccess: [
      { action: actions.setStatus, redux: true },
      ...(hooks?.onSuccess ? [hooks.onSuccess] : [])
    ],
    onError: [
      { action: actions.setLoadingError, redux: true },
      ...(hooks?.onError ? [hooks.onError] : [])
    ]
  }
}

export const getAccelerateAccess = (hooks) => {
  return {
    eventName: 'accelerateGetAccess',
    onSuccess: [
      { action: actions.setAccess, redux: true },
      ...(hooks?.onSuccess ? [hooks.onSuccess] : [])
    ],
    onError: [
      { action: actions.setAccessError, redux: true },
      ...(hooks?.onError ? [hooks.onError] : [])
    ]
  }
}

export const launchSkillBuilder = (hooks) => {
  return {
    eventName: 'accelerateLaunchSkillBuilder',
    onSuccess: hooks?.onSuccess ? [hooks.onSuccess] : [],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}

export const getAssessmentReport = (hooks) => {
  return {
    eventName: 'accelerateGetAssessmentReport',
    onSuccess: [
      { action: actions.setReport, redux: true },
      ...(hooks?.onSuccess ? [hooks.onSuccess] : [])
    ],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}

export const getRecommendations = (hooks) => {
  return {
    eventName: 'accelerateGetRecommendations',
    onSuccess: [
      { action: actions.setRecommendations, redux: true }
    ],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}

export const getProgress = (hooks) => {
  return {
    eventName: 'accelerateGetProgress',
    onSuccess: [
      { action: actions.setProgress, redux: true },
      ...(hooks?.onSuccess ? [hooks.onSuccess] : [])
    ],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}

export const launchAssessment = (hooks) => {
  return {
    eventName: 'accelerateLaunchAssessment',
    onSuccess: hooks?.onSuccess ? [hooks.onSuccess] : [],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}

export const markBadgeSeen = (hooks) => {
  return {
    eventName: 'accelerateMarkBadgeSeen',
    onSuccess: hooks?.onSuccess ? [hooks.onSuccess] : [],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}

export const trackApplySkillsInteraction = (hooks) => {
  return {
    eventName: 'accelerateTrackApplySkillsInteraction',
    onSuccess: [
      {
        action: (payload) => actions.setBadges(payload?.badges),
        redux: true
      },
      ...(hooks?.onSuccess ? [hooks.onSuccess] : [])
    ],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}

// DEV ONLY: Mark a course as completed for testing purposes
export const devCompleteCourse = (hooks) => {
  return {
    eventName: 'accelerateDevCompleteCourse',
    onSuccess: [
      { action: actions.setProgress, redux: true },
      ...(hooks?.onSuccess ? [hooks.onSuccess] : [])
    ],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}

// DEV ONLY: Complete assessment with custom scores for testing recommendations
export const devCompleteAssessment = (hooks) => {
  return {
    eventName: 'accelerateDevCompleteAssessment',
    onSuccess: [
      { action: actions.setStatus, redux: true },
      ...(hooks?.onSuccess ? [hooks.onSuccess] : [])
    ],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}

// DEV ONLY: Get assessment config with benchmark scores for dev complete modal
export const devGetAssessmentConfig = (hooks) => {
  return {
    eventName: 'accelerateDevGetAssessmentConfig',
    onSuccess: hooks?.onSuccess ? [hooks.onSuccess] : [],
    onError: hooks?.onError ? [hooks.onError] : []
  }
}
